import axios from "axios";

export function logError(message, source, lineNo, colno, error, stackFromOutside) {
    let stack = stackFromOutside || "";
    try {
        if (error && error.stack) {
            stack += "\nError stack:\n" + error.stack;
        }
    } catch (ignored) {
        // Ignore, we can't read the error
    }
    axios.post('/apiv2/crash', {
        message,
        source,
        lineNo,
        colno,
        error: error.toString(),
        stack,
        severity: "error",
        userAgent: window?.navigator?.appVersion
    }).then(() => {
        console.log("Sent error to backend");
    });
}